enum ColumnType {
	ID,
	Number,
	Text,
	RichText,
	URLs
}

export default ColumnType;